<template>
  <div class="login-spacing">
    <h1>Telefonnr. für Bestätigungscode</h1>
    <div class="login-form-wrapper">

      <b-alert v-model="hasUnknownError" variant="danger">
        {{ unknownErrorMessage }}
      </b-alert>

      <b-alert v-model="hasError" variant="danger">
        {{ errorMessage }}
      </b-alert>

      <b-alert v-model="isSucceded" variant="success" v-if="isSucceded">
        Die Telefonnr. wurde erfolgreich geändert.
        <router-link to="/">zum Login</router-link>
      </b-alert>

      <validation-observer ref="observer" v-slot="{ passes }" v-else>
        <b-form @submit.prevent="passes(onSubmit)" @reset.prevent="reset">

          <validation-provider vid="newNumber" rules="phoneNumber" name="newNumber" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-new-number" label="Telefonnr." label-for="input-new-number">
              <b-form-input
                id="input-new-number"
                v-model="form.newNumber"
                :state="onValidateField(valid, errors, changed)"
                placeholder="Format: +41 79 999 99 99"
              ></b-form-input>
              <small>Sie erhalten beim Einloggen einen Bestätigungscode auf diese Telefonnr.</small>
              <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <b-button type="submit" variant="primary" class="w-100" disabled v-if="isSubmitting">
            <b-spinner small></b-spinner>
            Speichern
          </b-button>
          <b-button type="submit" variant="primary" class="w-100" v-else>Speichern</b-button>
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { errorHandler, validateField } from '@/helpers/formHelper.js'

  const getInitialData = () => ({
    form: {
      newNumber: ''
    }
  })

  export default {
    components: {
      ValidationObserver,
      ValidationProvider
    },
    data: () => ({
      isSubmitting: false,
      isSucceded: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      ...getInitialData()
    }),
    methods: {
      async onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('user/CHANGE_MOBILE_NUMBER', this.form).then(res => {
          const { data, errors } = res

          if (errors) {
            const error = errors[0].extensions

            if (error.code === 'LOGIN_SESSION_EXPIRED') {
              this.$router.push({ name: 'login' }).catch((e) => {})
            }

            this.isSubmitting = false
            return errorHandler(this, errors)
          }

          const { ok } = data.userChangeIdentificationNumber
          if (ok) {
            this.isSucceded = true
          }
          this.isSubmitting = false
          this.reset()
        }).catch(err => {
          this.isSubmitting = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-spacing{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }
  .login-form-wrapper{
    max-width: 320px;
    margin: 0 auto;
  }

  .alert-success a{
    color: #155724;
  }
</style>
